export const COMMON_ROUTE = {
	gameRules: {
		root: "game-rules",
		casino: "game-rules.casino",
		sportsbook: "game-rules.sportsbook",
		livecasino: "game-rules.livecasino",
		virtualsports: "game-rules.virtualsports",
		poker: "game-rules.poker",
		racebets: "game-rules.racebets",
	},
	cookiePolicy: "cookie-policy",
	privacyPolicy: "privacy-policy",
	antiMoneyLaundering: "anti-money-laundering",
	personalData: "personal-data",
	termsAndConditions: {
		root: "terms-and-conditions",
		history: "terms-and-conditions.history",
	},
	securityOptions: "security-options",
	cashDesks: "cash-desks",
	groupCompanies: "group-companies",
	complaints: "complaints",
	licenseOverview: "license-overview",
	legalDisclosure: "legal-disclosure",
	aboutUs: "about-us",
	sportBlog: "sport-blog",
	press: "press",
};
